import React from 'react';

export const OrderOrderPopupIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40.705" height="50.131" viewBox="0 0 40.705 50.131">
            <g id="Icon_feather-file-minus" data-name="Icon feather-file-minus" transform="translate(-4.5 -1.5)">
                <path id="Path_1383" data-name="Path 1383" d="M29.565,3H10.713A4.713,4.713,0,0,0,6,7.713v37.7a4.713,4.713,0,0,0,4.713,4.713H38.992A4.713,4.713,0,0,0,43.7,45.418V17.139Z" fill="none" stroke="#179474" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"/>
                <path id="Path_1384" data-name="Path 1384" d="M21,3V17.139H35.139" transform="translate(8.565)" fill="none" stroke="#179474" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"/>
                <path id="Icon_awesome-arrow-circle-right" data-name="Icon awesome-arrow-circle-right" d="M8.354.563A7.791,7.791,0,1,1,.563,8.354,7.79,7.79,0,0,1,8.354.563ZM7.446,5.074,9.818,7.348H4.081a.752.752,0,0,0-.754.754v.5a.752.752,0,0,0,.754.754H9.818L7.446,11.633a.755.755,0,0,0-.013,1.078l.346.342a.751.751,0,0,0,1.065,0l4.169-4.166a.751.751,0,0,0,0-1.065L8.844,3.651a.751.751,0,0,0-1.065,0l-.346.342a.759.759,0,0,0,.013,1.081Z" transform="translate(16.499 24.368)" fill="#179474"/>
            </g>
        </svg>


    );
};
